
































import Vue from 'vue';
import Component from 'vue-class-component';
import { subscribeApis } from '@/api';

@Component
export default class Subscribe extends Vue {
  emails: Array<string> | null | any = null;

  created() {
    subscribeApis
      .subscribe()
      .then(() => {
        this.$notify.success('成功订阅');
      })
      .catch(e => {
        this.$notify.error(e.toString());
      })
      .finally(() => {
        subscribeApis.all_subscribers().then(emails => (this.emails = emails));
      });
  }

  hasPerm(name: string) {
    return this.$store.getters['perms/has'](name);
  }

  exportSubscriber() {
    const oInput = document.createElement('input');
    oInput.value = this.emails.toString();
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象;
    document.execCommand('Copy');
    this.$notify.success('成功复制到剪切板');
    this.emails = null;
  }
}
